import { useCallback } from "react";
import MailingsService from "../../../services/mailings";
import { useDownloadFile } from "../../../lib/hooks/useDownloadFIle";

export const useDownload = () => {
  const { download } = useDownloadFile();

  const onDownload = useCallback(
    (file: any): void => {
      download(MailingsService, file.response, file.name);
    },
    [download]
  );

  return { onDownload };
};
